import ipConfig from '../../../config/ip.config'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import Cookies from 'js-cookie'
const user = {
  namespaced: true,
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },
  actions: {
    logout({ commit }) {
      const rootDomain = location.hostname.split('.').reverse().splice(0, 2).reverse().join('.')
      Cookies.remove('MW_USERCENTER_TOKEN', { path: '/', domain: `.${rootDomain}` })
      Cookies.remove('MW_USERCENTER_INFO', { path: '/', domain: `.${rootDomain}` })
      Vue.ls.remove(USER_INFO)
      Vue.ls.remove(ACCESS_TOKEN)
      commit('SET_TOKEN', '')
      commit('SET_INFO', {})
      window.location.href = ipConfig.LOGINURL
    }
  }
}

export default user
